import axios from 'axios';
import { cancelAction } from './CancelSlice';

const getCancelData = (token, withRefund = true) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/subscription/cancel`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.post(url, { withRefund }, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      dispatch(cancelAction.cancelSuccess(result.data));
    } catch (e) {
      dispatch(cancelAction.cancelFailure(e.response?.data ?? e.message));
    }
  };
};

export default getCancelData;